<template>
  <div v-if="UserInfo.IsMultiAffiliation">
    <div
      v-if="AffiliationOptions && AffiliationOptions.length > 0"
      class="flex flex-row gap-2 items-center p-2"
    >
      <CustomIonSelect
        inputId="adminAffiliation"
        inputPlaceholder="Select an Affiliation"
        :dropdownItems="AffiliationOptions"
        :initialValue="SelectedAffiliation ? SelectedAffiliation.Id : undefined"
        :isFilterable="true"
        :isMandatory="true"
        @onChange="onAffiliationChange"
        :key="ReloadAffiliationsKey"
        :isDisabled="isDisabled"
        class="flex-1"
      />
      <CustomIonSwitch
        inputId="affiliationStatusSwitch"
        :initialValue="CurrentAffiliationStatus"
        :inactiveValue="ActiveInactiveStatusEnum.INACTIVE"
        :activeValue="ActiveInactiveStatusEnum.ACTIVE"
        :isDisabled="isDisabled"
        activeColor="tertiary"
        size="small"
        @onChange="onAffiliationStatusChange"
      />
    </div>
    <div v-else-if="DataLoading" class="px-2 pb-2 grid-cols-1 m:grid-cols-2 grid gap-2.5 items-end">
      <SkeletonShimmerBase>
        <div class="row-center-gap-2">
          <SkeletonItem variant="rect" height="30px" />
          <SkeletonItem variant="rect" width="20%" height="30px" />
        </div>
      </SkeletonShimmerBase>
    </div>
  </div>
</template>
<script lang="ts">
import CustomIonSelect from "@/components/inputs/CustomIonSelect.vue";
import CustomIonSwitch from "@/components/inputs/CustomIonSwitch.vue";
import SkeletonItem from "@/components/skeletons/SkeletonItem.vue";
import SkeletonShimmerBase from "@/components/skeletons/SkeletonShimmerBase.vue";
import { ActiveInactiveStatusEnum } from "@/enums/global";
import { useAffiliationStore } from "@/stores/affiliation/affiliationStore";
import { useParentAffiliationStore } from "@/stores/affiliation/parentAffiliationStore";
import { useSessionStore } from "@/stores/core/sessionStore";
import { storeToRefs } from "pinia";
import { defineComponent, onBeforeMount, onBeforeUnmount } from "vue";

export default defineComponent({
  name: "TheAffiliationSelector",
  components: { CustomIonSelect, CustomIonSwitch, SkeletonShimmerBase, SkeletonItem },
  props: { isDisabled: { type: Boolean, default: false } },
  setup() {
    const sessionStore = useSessionStore();
    const { UserInfo } = storeToRefs(sessionStore);
    const parentAffiliationStore = useParentAffiliationStore();
    const { onAffiliationStatusChange, updateSelectedAffiliation } = parentAffiliationStore;
    const {
      AffiliationOptions,
      CurrentAffiliationStatus,
      SelectedAffiliation,
      IsSelectorActive,
      ReloadAffiliationsKey,
      DataLoading,
    } = storeToRefs(parentAffiliationStore);
    const affiliationStore = useAffiliationStore();
    const { SelectedBatch } = storeToRefs(affiliationStore);

    onBeforeMount(async () => {
      IsSelectorActive.value = true;
    });

    onBeforeUnmount(async () => {
      IsSelectorActive.value = false;
    });

    async function onAffiliationChange(affiliationId: number) {
      SelectedBatch.value = null;
      updateSelectedAffiliation(affiliationId);
    }

    return {
      UserInfo,
      ActiveInactiveStatusEnum,
      AffiliationOptions,
      SelectedAffiliation,
      CurrentAffiliationStatus,
      ReloadAffiliationsKey,
      DataLoading,
      onAffiliationStatusChange,
      onAffiliationChange,
    };
  },
});
</script>
